<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">

        <!-- 操作按钮区域 -->
        <el-row class="table-header">
          <el-col>
            <div class="action-buttons">
              <el-button 
                type="primary" 
                size="medium" 
                icon="el-icon-upload2" 
                @click="triggerFileUpload" 
                :disabled="loadingStaus"
                class="action-btn">
                <span>导入数据</span>
              </el-button>
              <input type="file" accept=".xlsx" ref="fileInput" @change="handleFileUpload" style="display: none;" />
              
              <el-button 
                type="success" 
                size="medium" 
                icon="el-icon-download" 
                @click="downloadButton()"
                class="action-btn">
                <span>导出数据</span>
              </el-button>
              <el-button
                type="danger"
                size="medium"
                icon="el-icon-delete"
                @click="batchDelete"
                :disabled="loadingStaus || selectedRows.length === 0"
                class="action-btn">
                <span>批量删除</span>
              </el-button>
              
              <el-tooltip effect="dark" content="添加新的可达区域" placement="top">
                <el-button 
                  type="primary" 
                  size="medium" 
                  icon="el-icon-plus" 
                  @click="addButton()"
                  class="action-btn add-btn">
                  <span>添加地址</span>
                </el-button>
              </el-tooltip>
            </div>
          </el-col>
        </el-row>

        <!-- 搜索区域 -->
        <div class="search-section">
          <el-card shadow="never" class="search-card">
            <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
              <el-form-item label="可达地址" class="search-item">
                <el-input 
                  v-model="searchCondition.address_name" 
                  placeholder="请输入可达地址名称" 
                  clearable
                  prefix-icon="el-icon-location"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item label="邮编" class="search-item">
                <el-input 
                  v-model="searchCondition.post_code" 
                  placeholder="请输入邮政编码" 
                  clearable
                  prefix-icon="el-icon-postcard"
                  class="search-input">
                </el-input>
              </el-form-item>
              
              <el-form-item class="search-actions">
                <el-button 
                  type="primary" 
                  @click="searchButton"
                  icon="el-icon-search"
                  class="search-btn">
                  查询
                </el-button>
                <el-button 
                  @click="resetSearch"
                  icon="el-icon-refresh"
                  class="reset-btn">
                  重置
                </el-button>
              </el-form-item>
            </el-form>
          </el-card>
        </div>

        <!-- 数据表格区域 -->
        <div class="table-section">
          <el-card shadow="never" class="table-card">
            <ApeTable 
              ref="apeTable" 
              :data="dataList" 
              :loading="loadingStaus" 
              :pagingData="pagingData" 
              @switchPaging="switchPaging" 
              @selectList="handleSelectList"
              highlight-current-row 
              border
              class="data-table">
              <el-table-column type="selection" width="55" align="center"></el-table-column>
              
              <el-table-column
                label="地址名称"
                prop="address_name"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <div class="address-cell">
                    <i class="el-icon-location-outline cell-icon"></i>
                    <span class="address-text">{{scope.row.address_name}}</span>
                  </div>
                </template>
              </el-table-column>
              
              <el-table-column
                label="邮政编码"
                prop="post_code"
                align="center">
                <template slot-scope="scope">
                  <el-tag size="small" type="info">{{scope.row.post_code}}</el-tag>
                </template>
              </el-table-column>
              
              <el-table-column
                label="层级"
                prop="level"
                align="center">
                <template slot-scope="scope">
                  <el-badge :value="scope.row.level" class="level-badge">
                    <i class="el-icon-menu"></i>
                  </el-badge>
                </template>
              </el-table-column>
              
              <el-table-column
                label="状态"
                prop="address_status"
                align="center">
                <template slot-scope="scope">
                  <el-switch
                    v-model="scope.row.address_status"
                    @change="changeStatus(scope.row)"
                    active-value="1"
                    inactive-value="0"
                    active-color="#67C23A"
                    inactive-color="#F56C6C"
                    active-text="启用"
                    inactive-text="禁用">
                  </el-switch>
                </template>
              </el-table-column>
              
              <el-table-column
                v-if="buttonType=='icon'"
                label="操作"
                width="150"
                align="center"
                fixed="right">
                <template slot-scope="scope">
                  <div class="operation-buttons">
                    <el-tooltip effect="dark" content="编辑地址信息" placement="top">
                      <el-button 
                        size="mini" 
                        type="primary"
                        icon="el-icon-edit" 
                        @click="editButton(scope.row.id)"
                        class="op-btn">
                      </el-button>
                    </el-tooltip>
                    
                    <el-tooltip effect="dark" content="查看下级地址" placement="top">
                      <el-button 
                        size="mini" 
                        type="success"
                        icon="el-icon-arrow-down" 
                        @click="getNode(scope.row.id)"
                        class="op-btn">
                      </el-button>
                    </el-tooltip>
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      class="op-btn"
                      @click="confirmDelete(scope.row.id)">
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </ApeTable>
          </el-card>
        </div>
      </div>
    </PageHeaderLayout>

    <!-- 编辑弹窗 -->
    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <div class="form-container">
          <el-form 
            :model="formData" 
            :rules="rules" 
            ref="dataForm" 
            label-position="left" 
            label-width="100px"
            class="drawer-form">
            
            <el-form-item label="地址名称" prop="address_name">
              <el-input 
                v-model="formData.address_name"
                placeholder="请输入地址名称"
                prefix-icon="el-icon-location">
              </el-input>
            </el-form-item>
            
            <el-form-item label="邮政编码" prop="post_code">
              <el-input 
                v-model="formData.post_code"
                placeholder="请输入邮政编码"
                prefix-icon="el-icon-postcard">
              </el-input>
            </el-form-item>
            
            <el-form-item label="启用状态" prop="address_status">
              <el-switch
                v-model="formData.address_status"
                active-value="1"
                inactive-value="0"
                active-color="#67C23A"
                inactive-color="#F56C6C"
                active-text="启用"
                inactive-text="禁用">
              </el-switch>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </ApeDrawer>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import { mapGetters } from 'vuex'
import ApeUploader from '@/components/ApeUploader'
import * as XLSX from 'xlsx';
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ApeDrawer,
    ApeUploader
  },
  data() {
    return {
      // 搜索条件
      searchCondition:{
        current_page: 1,
        page_size: 20,
        address_name:'',
        post_code:'',
        query: "pid=?",
        params: ["0"],
      },
      loadingStaus: true,
      // 表格列表数据
      dataList:[],
      selectedRows: [],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      region_info:{
        region:0,
      },
      // 表单结构
      formData: {
        id:0,
      },
      // 表单验证
      rules: {
        address_name: [{required: true,message:'输入可达地址名称', trigger: 'blur' }],
        post_code: [{required: true,message:'输入邮编', trigger: 'blur' }],
      },
      // 抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '权限绑定',
        width_height: '480',
      },
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  methods: {
    normalizeExcelRows(worksheet) {
      const matrix = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: '', raw: false })
      const rows = (matrix || []).map(row => (row || []).map(cell => String(cell || '').trim()))
      const headerHints = ['地址', '国家', '地区', '名称', 'address', 'name', '邮编', '邮政编码']
      let headerIndex = rows.findIndex(row => row.some(cell => headerHints.some(h => cell.toLowerCase().includes(h.toLowerCase()))))
      if (headerIndex < 0) headerIndex = 0
      const headerRow = rows[headerIndex] || []
      const dataRows = rows.slice(headerIndex + 1).filter(row => row.some(cell => cell !== ''))
      return dataRows.map(row => {
        const item = {}
        headerRow.forEach((key, index) => {
          const finalKey = key || `__col_${index}`
          item[finalKey] = row[index] || ''
        })
        return item
      })
    },
    inferAddressName(item) {
      const direct = this.pickImportValue(item, [
        '地址',
        '国家/地区',
        '国家地区',
        '国家或地区',
        '国家（地区）',
        '国家/地区名称',
        '国家地区名称',
        '国家或地区名称',
        '标准名称',
        '中文名称',
        '英文名称',
        'name',
        'address_name'
      ])
      if (direct) return direct
      const values = Object.keys(item).map(key => String(item[key] || '').trim()).filter(Boolean)
      return values.length ? values[0] : ''
    },
    pickImportValue(item, keys = []) {
      for (const key of keys) {
        if (Object.prototype.hasOwnProperty.call(item, key)) {
          const value = item[key]
          if (value !== undefined && value !== null) {
            const text = String(value).trim()
            if (text !== '') return text
          }
        }
      }
      return ''
    },
    handleSelectList(list) {
      this.selectedRows = list || []
    },
    // 重置搜索
    resetSearch() {
      this.searchCondition.address_name = ''
      this.searchCondition.post_code = ''
      this.searchCondition.current_page = 1
      this.getList()
    },
    // 搜索按钮
    searchButton() {
      this.searchCondition.current_page = 1
      this.getList()
    },
    getNode(id){
      window.open('/express/'+id+'/address_node','_blank')
    },
    async changeStatus(row){
      let res = await this.$api.post('/service/ola_app_arrive_address/update',row)
      if (this.$apiSuccess(res)){
        this.$message.success('状态修改成功!')
      }
    },
    triggerFileUpload() {
      this.loadingStaus = true
      this.$refs.fileInput.click()
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          // 处理工作簿内容
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = this.normalizeExcelRows(worksheet);
          this.importData(jsonData)
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.loadingStaus = false
      }
      event.target.value = ''
    },
    async importData(jsonData) {
      let datas = jsonData.map(item => {
        const statusRaw = this.pickImportValue(item, ['状态', 'address_status', 'status'])
        const isEnabled = statusRaw === undefined || statusRaw === null || statusRaw === '' || statusRaw === '启用' || statusRaw === '1' || statusRaw === 1 || statusRaw === true
        const addressName = this.inferAddressName(item)
        const postCode = this.pickImportValue(item, ['邮编', '邮政编码', 'post_code', 'postcode', 'zip', 'zip_code'])
        const levelRaw = this.pickImportValue(item, ['层级', 'level'])
        const levelNum = Number(levelRaw)
        return {
          "pid": this.$route.params.id,
          "address_name": addressName,
          "post_code": postCode,
          "address_status": isEnabled ? '1' : '0',
          "level": Number.isFinite(levelNum) && levelNum > 0 ? levelNum : '',
        }
      }).filter(v => v.address_name);
      if (datas.length === 0) {
        this.loadingStaus = false
        this.$message.warning('未识别到有效导入数据')
        return
      }
      let res = await this.$api.post('/service/ola_app_arrive_address/import',{datas:datas,unique_key:"pid,post_code,address_name"})
      if (this.$apiSuccess(res)){
        this.$message.success('导入成功!')
        this.getList()
      }else{
        this.$message.error(res.message)
      }
      this.loadingStaus = false
    },
    // 设置搜索条件（修复分页参数冲突问题）
    setSearchCondition() {
      this.loadingStaus = true
      
      // 基础查询条件
      this.searchCondition.query = 'pid=?'
      this.searchCondition.params = [this.$route.params.id]
      
      // 地址名称搜索条件
      if (this.searchCondition.address_name != ''){
        this.searchCondition.query += ' and instr(address_name,?)>0'
        this.searchCondition.params.push(this.searchCondition.address_name)
      }
      
      // 邮编搜索条件
      if (this.searchCondition.post_code != ''){
        this.searchCondition.query += ' and post_code=?'
        this.searchCondition.params.push(this.searchCondition.post_code)
      }
    },
    // 切换页码或每页条数（优化分页逻辑）
    async switchPaging({ current_page, page_size }) {
      console.log('分页切换:', { current_page, page_size })
      
      // 直接使用传入的分页参数，避免从组件重复获取
      this.searchCondition.current_page = current_page
      this.searchCondition.page_size = page_size
      
      // 调用列表获取，但不要重新设置分页参数
      await this.getListWithPaging()
    },
    // 新增：带分页参数的列表获取方法
    async getListWithPaging() {
      this.setSearchCondition()
      
      console.log('发送分页请求:', {
        current_page: this.searchCondition.current_page,
        page_size: this.searchCondition.page_size,
        query: this.searchCondition.query,
        params: this.searchCondition.params
      })
      
      let res = await this.$api.post('/service/ola_app_arrive_address/list', this.searchCondition)
      
      if (this.$apiSuccess(res)){
        this.dataList = res.data.list
        this.pagingData.total = res.data.page.total
        
        // 确保分页组件状态同步
        this.searchCondition.current_page = res.data.page.current_page
        this.searchCondition.page_size = res.data.page.page_size
        
        console.log('分页响应:', {
          total: this.pagingData.total,
          current_page: res.data.page.current_page,
          page_size: res.data.page.page_size,
          list_count: this.dataList.length
        })
      }else{
        this.dataList = []
        this.pagingData.total = 0
        this.$message.error(res.message)
      }
      
      this.loadingStaus = false
    },
    // 响应添加按钮
    async addButton() {
      this.drawerData.visible = true
      this.drawerData.title = '添加数据'
      this.drawerData.loading = false
    },
    // 响应编辑按钮
    async editButton(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑数据(UID：'+id+')'
      let res = await this.$api.post('/service/ola_app_arrive_address/detail',{id:id})
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initFormData()
      this.drawerData.visible = false
      this.drawerData.loading = true
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // form数据提交，请求接口
    async formSubmit() {
      let id = this.$route.params.id
      let parantres = await this.$api.post('/service/ola_app_arrive_address/detail',{id:id})
      if (this.$apiSuccess(parantres)){
        this.formData.level = parantres.data.detail.level+1
      }else{
        this.$message.error(parantres.message)
      }
      this.drawerData.loading_text = '玩命提交中……'
      this.drawerData.loading = true
      let url = '/service/ola_app_arrive_address/create'
      const isCreate = !this.formData.id
      if(this.formData.id!=''){
        url = '/service/ola_app_arrive_address/update'
      }
      let res = await this.$api.post(url,this.formData)
      if (this.$apiSuccess(res)){
        this.formData = res.data.detail
        this.$message.success(isCreate ? '添加成功' : '更新成功')
        if (isCreate) this.searchCondition.current_page = 1
        await this.getList()
      }else{
        this.$message.error(res.message)
      }
      this.drawerData.loading = false
      this.drawerData.visible = false
    },
    clearActiveFocus() {
      this.$nextTick(() => {
        const activeEl = document.activeElement
        if (activeEl && typeof activeEl.blur === 'function') {
          activeEl.blur()
        }
      })
    },
    async confirmDelete(id) {
      try {
        await this.$confirm('确认删除该地址吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await this.deleteButton(id)
      } catch (e) {
        // 用户取消删除时不提示错误
      }
    },
    // 相应删除按钮
    async deleteButton(id) {
      this.clearActiveFocus()
      let info = await this.$api.post('/service/ola_app_arrive_address/delete',{id:id})
      if (this.$apiSuccess(info)) {
        this.$message.success('删除成功!')
        await this.getList()
      } else {
        this.$message.error(info.message || '删除失败')
      }
      
    },
    async batchDelete() {
      if (!this.selectedRows.length) return
      const ids = this.selectedRows.map(v => v.id).filter(Boolean)
      if (!ids.length) return
      const res = await this.$api.post('/service/ola_app_arrive_address/delete_batch', {
        query: 'id in (?)',
        params: [ids]
      })
      if (this.$apiSuccess(res)) {
        this.$message.success('批量删除成功')
        this.selectedRows = []
        await this.getList()
      } else {
        this.$message.error(res.message || '批量删除失败')
      }
    },
    // 初始化数据
    initFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.formData = {id:0}
        this.$refs['dataForm'].resetFields()
      })
    },
    // 修改：初始化数据列表（用于首次加载和搜索）
    async getList() {
      // 只在首次加载时获取分页信息，搜索时保持当前设置
      if (this.$refs['apeTable'] && this.searchCondition.current_page === 1) {
        let pagingInfo = this.$refs['apeTable'].getPagingInfo() 
        this.searchCondition.page_size = pagingInfo.page_size
        this.searchCondition.current_page = pagingInfo.current_page
      }
      
      await this.getListWithPaging()
    },
    async uploadButton() {
      console.log('uploadButton')
    },
    async downloadButton() {
      let searchCondition = {...this.searchCondition}
      delete searchCondition.page_size
      delete searchCondition.current_page
      let res = await this.$api.post('/service/ola_app_arrive_address/list',searchCondition)
      if (this.$apiSuccess(res)){
        let data = res.data.list
        const filteredData = data.map(item => ({
          "地址": item.address_name,
          "邮编": item.post_code,
          "层级": item.level,
          "状态": item.address_status=='1'?'启用':'禁用'
        }));
        const worksheet = XLSX.utils.json_to_sheet(filteredData, {
          header: ['地址', '邮编', '层级', '状态']
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '可达地址');
        XLSX.writeFile(workbook, '可达地址.xlsx');
      }
    },
  },
  mounted() {
    this.searchCondition.query = 'pid=?'
    this.searchCondition.params = [this.$route.params.id]
    this.getList()
  },
}
</script>

<style lang="stylus" scoped>
// 页面标题样式
.page-title-section
  margin-bottom 24px
  padding 16px 0
  border-bottom 1px solid #E4E7ED
  
  .page-title
    font-size 24px
    font-weight 600
    color #303133
    margin 0 0 8px 0
    
  .page-subtitle
    font-size 14px
    color #909399
    margin 0

// 操作按钮区域样式
.table-header
  margin-bottom 16px
  
  .action-buttons
    display flex
    gap 12px
    
    .action-btn
      display flex
      align-items center
      gap 8px
      padding 10px 16px
      border-radius 6px
      transition all 0.3s ease
      
      &:hover
        transform translateY(-1px)
        box-shadow 0 4px 12px rgba(0,0,0,0.15)
        
    .add-btn
      background linear-gradient(135deg, #409EFF 0%, #67C23A 100%)
      border none
      
      &:hover
        background linear-gradient(135deg, #337ecc 0%, #529b2e 100%)

// 搜索区域样式
.search-section
  margin-bottom 16px
  
  .search-card
    border-radius 8px
    box-shadow 0 2px 8px rgba(0,0,0,0.1)
    
    .search-form
      .search-item
        margin-right 24px
        margin-bottom 0
        
        .search-input
          width 200px
          
      .search-actions
        margin-right 0
        
        .search-btn
          background #409EFF
          border-color #409EFF
          padding 8px 20px
          
        .reset-btn
          margin-left 8px
          padding 8px 16px

// 表格区域样式  
.table-section
  .table-card
    border-radius 8px
    box-shadow 0 2px 8px rgba(0,0,0,0.1)
    
    .data-table
      /deep/ .el-table
        border-radius 8px
        overflow hidden
        
        th
          background #F5F7FA
          color #606266
          font-weight 600
          
        .address-cell
          display flex
          align-items center
          gap 8px
          
          .cell-icon
            color #409EFF
            font-size 16px
            
          .address-text
            color #303133
            
        .level-badge
          /deep/ .el-badge__content
            background #E6A23C
            border-color #E6A23C
            
        .operation-buttons
          display flex
          gap 8px
          justify-content center
          
          .op-btn
            padding 4px 8px
            border-radius 4px
            
            &:hover
              transform scale(1.1)

// 抽屉表单样式
.form-container
  padding 20px
  
  .drawer-form
    /deep/ .el-form-item
      margin-bottom 24px
      
      .el-form-item__label
        font-weight 600
        color #606266
        
      .el-input
        .el-input__inner
          border-radius 6px
          border-color #DCDFE6
          transition all 0.3s ease
          
          &:focus
            border-color #409EFF
            box-shadow 0 0 0 2px rgba(64,158,255,0.2)
</style>
